import {React, useState} from "react";
import {Card, Text} from "retro-react";
import { CSSTransition } from "react-transition-group";
import useIsMobile from '../../hooks/useIsMobile'
import './AlbumCard.css'
import { fetchMedia } from "../../api/media";
import { useApi } from "../../hooks/useApi";
import { LoadingBox } from "../../components/LoadingBox";

const AlbumCard = ({
  objectKey,
  frontImageId,
  rearImageId,
  albumTitle,
  artistName,
  role,
  blurb,
  albumUrl,
  albumUrlText

  }) => {
      const {output: frontImageObject, loading: frontLoading, error: frontError} = useApi(fetchMedia, frontImageId);
      const {output: rearImageObject, loading: rearLoading, error: rearError} = useApi(fetchMedia, rearImageId);

      const frontImageUrl = frontImageObject?.source_url
      const rearImageUrl = rearImageObject?.source_url

      // dynamically adjust font for the album title
      const baseFontSizeA = 725; // Adjust this to tune the scaling
      const baseFontSizeB = 560; // Adjust this to tune the scaling
      const titleFontSize = `clamp(16.5px, ${baseFontSizeA / albumTitle.length}px, 28px)`;
      const titleFontSizeMobile = `clamp(15px, ${baseFontSizeB / albumTitle.length}px, 28px)`;
      const artistFontSize = `clamp(10px, ${baseFontSizeA / artistName.length}px, 24px)`;
      const artistFontSizeMobile = `clamp(10px, ${baseFontSizeB / artistName.length}px, 24px)`;

    const [flipped, setFlipped] = useState(true);
    const isMobile = useIsMobile(1250);

    const handleFlip = () => {
      setFlipped(!flipped);
    };


    if (frontLoading){
      return(
        <div className="card-image-spinner">
          <LoadingBox/>
        </div>
      );
    }

    const FrontSide = () => {
       
      return(
        <Card className="card"
        color="primary"
        rounded
        sx={{
            maxHeight: '500px',
            maxWidth: '1000px',
            height: '500px', 
            width: '400px'
          }}
        image= {frontImageUrl}
        onClick={handleFlip} 
        >
      <Text variant="h3"  align="center" style={{fontSize: `${titleFontSize}`}}  sx={{}} >
              {albumTitle} <br/>
           
           <Text align="center" variant="h6" bevel="true" style={{fontSize: `${artistFontSize}`}}>
            {artistName}
           </Text>

        </Text>
        
    </Card>
      );
    }

    const BackSide = () => { 
      return( 
        <Card className="card"
        color="primary"
        rounded
        sx={{
            maxHeight: '500px',
            maxWidth: '1000px',
            height: '500px', 
            width: '400px',
          }}
        onClick={handleFlip}
        >
        <img className="image-box" src={rearImageUrl}/>

        <Text variant="h6" style={{"font-size":"20px"}} align="center">
        {role} <br/>

          <Text variant="body1" style={{"font-size":"18px"}} align="center"> 
            {blurb}
           <br/> 
            <a href={albumUrl} target="_blank" > {albumUrlText} </a>
          </Text>
        
        </Text>
    </Card> 
      );
      
    }


    const MobileFrontSide = () => {
      return(
        <Card className="card"
        color="primary"
        rounded
        sx={{
            maxHeight: '500px',
            maxWidth: '1000px',
            width: '340px',
            height: '440px', 
          }}
        image= {frontImageUrl}
        onClick={handleFlip}
        >
        <Text variant="h3"  align="center" style={{fontSize: `${titleFontSizeMobile}`}}  sx={{}} >
        {albumTitle} <br/>
           
           <Text align="center" variant="h6" bevel="true" style={{fontSize: `${artistFontSizeMobile}`}}>
            {artistName}
           </Text>

        </Text>
        
    </Card>
      );
    }

    const MobileBackSide = () => { 
      return( 
        <Card className="card"
        color="primary"
        rounded
        sx={{
            maxHeight: '500px',
            maxWidth: '1000px',
            width: '340px',
            height: '440px',
          }}
        onClick={handleFlip}
        >
        
            <img className="image-box" src={rearImageUrl}/>
    
      <Text variant="h3"  align="center" style={{fontSize: `${titleFontSize}px`}}  sx={{}} >
        {role} <br/>

          <Text variant="body1" style={{"font-size":"18px"}} align="center"> 
            {blurb}
            <a href={albumUrl} target="_blank"> {albumUrlText} </a>
          </Text>
        
        </Text>
    </Card> 
      );
      
    }



    return(
      <div className="flip-container">
        <CSSTransition
              in={flipped}
              timeout={200}
              classNames="flip"
              unmountOnExit
              >
              {isMobile ? <MobileFrontSide/> : <FrontSide/>}
          </CSSTransition>

          {/* BACKSIDE */}
          
          <CSSTransition
            in={!flipped}
            timeout={200}
            classNames="flip"
            unmountOnExit
          >
            {isMobile ? <MobileBackSide/> : <BackSide/>}
          </CSSTransition>
        </div>
    );
}

export default AlbumCard